import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import styled from 'styled-components';
import { fontSize, fontFamily } from '../../../constants/text';
import { formatLocationImageTitle, formatLocationImageAlt } from '../../../core/util/seo';
import { isEmptyArray } from '../../../core/util/array';
import { isEmptyObject } from '../../../core/util/object';
import PanelCard from '../PanelCards/components/PanelCard';
import Picture from '../../SolvPatternLibrary/Picture/index';
import { getImageObject, PHOTO } from '../../SolvPatternLibrary/Picture/util';

const SectionBody = styled.div`
  display: flex;
`;

const StyledGridListTile = styled(GridListTile)`
  cursor: pointer;
  & > div {
    width: 300px;
    height: 200px;
  }
`;

const SizedPicture = styled(Picture)`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  left: 0;
  top: 0;
`;

const Overlay = styled(GridListTileBar)`
  width: 300px;
  height: 200px;
  text-align: center;
  color: white;
  font-size: ${fontSize.medium};
  font-family: ${fontFamily.bold};
`;

class Photos extends PureComponent {
  getImageData() {
    const { handleOpenCarousel, location, viewport } = this.props;
    const { imageLinks } = location;
    const photos =
      isEmptyObject(imageLinks) || isEmptyArray(imageLinks.image) ? [] : imageLinks.image;

    const img = [];

    for (let i = 0; i < Math.min(2, photos.length); i++) {
      if (i === 1) {
        img.push(
          <StyledGridListTile key={photos[i]} itemScope itemType="http://schema.org/ImageObject">
            <meta itemProp="name" content={location.name} />
            <meta itemProp="contentLocation" content={`${location.city}, ${location.state}`} />
            <meta
              itemProp="description"
              content={`Photo of ${location.name} (${location.city}, ${location.state})`}
            />
            <SizedPicture
              imageObject={getImageObject(location, {
                imageType: PHOTO,
                imageIndex: i,
                viewport,
              })}
              role="presentation"
              title={formatLocationImageTitle(location)}
              alt={formatLocationImageAlt(location)}
              itemProp="contentUrl"
            />
            <Overlay title="View All Photos" titlePosition="top" onClick={handleOpenCarousel} />
          </StyledGridListTile>
        );

        return img;
      }

      img.push(
        <StyledGridListTile
          key={photos[i]}
          itemScope
          itemType="http://schema.org/ImageObject"
          itemProp="image"
        >
          <meta itemProp="name" content={location.name} />
          <meta itemProp="url" content={photos[i]} />
          <meta itemProp="contentLocation" content={`${location.city}, ${location.state}`} />
          <meta
            itemProp="description"
            content={`Photo of ${location.name} (${location.city}, ${location.state})`}
          />
          <SizedPicture
            imageObject={getImageObject(location, {
              imageType: PHOTO,
              imageIndex: i,
              viewport,
            })}
            alt={`${location.name} (${location.city}, ${location.state}) - #${i}`}
            onClick={handleOpenCarousel}
            itemProp="contentUrl"
          />
        </StyledGridListTile>
      );
    }

    return img;
  }

  shouldRender = () => {
    const {
      location: { imageLinks },
    } = this.props;
    return !isEmptyObject(imageLinks) && !isEmptyArray(imageLinks.image);
  };

  render = () => {
    if (!this.shouldRender()) return null;

    const { enableCollapsing, defaultExpanded } = this.props;

    return (
      <PanelCard title="Photos" {...{ enableCollapsing, defaultExpanded }}>
        <Grid item>
          <SectionBody>
            <GridList cellHeight={200} cols={2}>
              {this.getImageData()}
            </GridList>
          </SectionBody>
        </Grid>
      </PanelCard>
    );
  };
}

export default Photos;

Photos.propTypes = {
  handleOpenCarousel: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  viewport: PropTypes.object,
  enableCollapsing: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
};

Photos.defaultProps = {
  location: {
    imageLinks: {},
  },
};
